import { all } from 'redux-saga/effects';

import consultarLocalidadesAssociada from './consultarLocalidadesAssociada/saga';

export default all([consultarLocalidadesAssociada]);
